var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUniversity = function SvgUniversity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#191F2E",
    d: "M21 9.5a1 1 0 0 0 1-1v-3a1 1 0 0 0-.684-.949l-9-3a1 1 0 0 0-.632 0l-9 3A1 1 0 0 0 2 5.5v3a1 1 0 0 0 1 1h1v7.184A2.995 2.995 0 0 0 2 19.5v2a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1v-2a2.995 2.995 0 0 0-2-2.816V9.5zm-1 11H4v-1a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1zm-14-4v-7h2v7zm4 0v-7h4v7zm6 0v-7h2v7zm-12-9V6.22l8-2.667 8 2.667V7.5z"
  })));
};
export default SvgUniversity;